import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpWall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-up-wall"} maskId="square-filled-radius-0-stroke-1-IconArrowUpWall"><path d="M20 21H4V20H20V21Z" fill="currentColor"/><path d="M17.707 8.5L17 9.20703L12.5 4.70703V17H11.5V4.70703L7 9.20703L6.29297 8.5L12 2.79297L17.707 8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowUpWall;
